import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4 16v1a3 3 0 0 0 3 3h1M16 20h1a3 3 0 0 0 3-3v-1M20 8V7a3 3 0 0 0-3-3h-1M4 8V7a3 3 0 0 1 3-3h1"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "1.778",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }